import React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { JobTemplateCategory } from './JobTemplateCategory';

export const JobTemplateList = ({ jobTemplateData }) => {

  const renderTemplateGroups = () => {
    return Object?.values(jobTemplateData || {})?.map((templates) => {
      return (
        <Col
          key={templates[0].tradeType}
          xs={6}
          sm={6}
          md={4}
          lg={4}
          fallback={12}
        >
          <JobTemplateCategory
            tradeType={templates[0].tradeType}
            jobTemplates={templates}
          />
        </Col>
      );
    }
    );
  };

  return (
    <Row style={{ padding: '10px' }}>
      {renderTemplateGroups()}
    </Row>
  );
};
